// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'core/store';
import { BrowserRouter as Router } from 'react-router-dom';

import './index.css';

import '@ingka/typography/dist/style.css';
import '@ingka/variables';
import '@ingka/grid/dist/style.css';
import '@ingka/table/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/link-list/dist/style.css';
import '@ingka/switch/dist/style.css';
import '@ingka/action-list/dist/style.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/choice/dist/style.css';
import '@ingka/search/dist/style.css';
import '@ingka/slider/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/toggle/dist/style.css';
import '@ingka/list/dist/style.css';
import '@ingka/carousel/dist/style.css';
import '@ingka/tabs/dist/style.css';
import '@ingka/pill/dist/style.css';
import '@ingka/status/dist/style.css';
import '@ingka/call-out/dist/style.css';
import '@ingka/loading/dist/style.css';
import '@ingka/accordion/dist/style.css';
import '@ingka/card/dist/style.css';
import '@ingka/tag/dist/style.css';
import '@ingka/tooltip/dist/style.css';
import '@ingka/toast/style.scss';

import {
  AuthConfigurationError,
  getRuntimeAuthConfig,
} from './core/auth/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './components/App';

const container = document.getElementById('root');
const root = createRoot(container);
export let msalInstance;

const renderConfigurationError = () => {
  root.render(
    <p>Authentication is unavailable. Please contact support.</p>
  );
};

try {
  const { msalConfig } = getRuntimeAuthConfig();
  msalInstance = new PublicClientApplication(msalConfig);

  msalInstance
    .initialize()
    .then(() => {
      root.render(
        <Provider store={store}>
          <Router basename={process.env.PUBLIC_URL || '/'}>
            <MsalProvider instance={msalInstance}>
              <React.StrictMode>
                <App />
              </React.StrictMode>
            </MsalProvider>
          </Router>
        </Provider>
      );

      if (import.meta.hot) {
        import.meta.hot.accept();
      }
    })
    .catch(renderConfigurationError);
} catch (error) {
  if (error instanceof AuthConfigurationError) {
    renderConfigurationError(error);
  } else {
    throw error;
  }
}
